import { Reducer } from 'redux'
import { ActionTypes, TGeneralActivityState } from './types'
import { getDataForPagination } from '../../../../utils/reducerUtils'

export const initialState: TGeneralActivityState = {
  loading: false,
  data: null,
}

const reducer: Reducer<TGeneralActivityState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_GENERAL_ACTIVITY_R:
      return { ...state, loading: true, errors: undefined }
    case ActionTypes.GET_GENERAL_ACTIVITY_S:
      return { ...state, loading: false, errors: undefined, data: getDataForPagination(state.data, action.payload) }
    case ActionTypes.GET_GENERAL_ACTIVITY_WITH_O_OFFSET_S:
      return { ...state, loading: false, errors: undefined, data: action.payload }
    case ActionTypes.GET_GENERAL_ACTIVITY_E:
      return { ...state, loading: false, errors: action.payload, data: [] }

    default:
      return state
  }
}

export { reducer as GeneralActivityReducer }
